document.addEventListener("DOMContentLoaded", function () {

  const wrapper = document.querySelector(".reel-wrapper");
  const modal = document.querySelector(".reel-modal");
  const slider = document.querySelector(".reel-slider");
  const floatVideo = document.querySelector(".reel-video");
  let globalSound = false;
  if (!wrapper || !modal || !slider) return;

  const videos = slider.querySelectorAll(".reel-slide video");

  /* ================= SVG ICONS ================= */

  const soundOnSVG = `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="white" stroke-width="2">
  <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
  <path d="M15.5 8.5a5 5 0 010 7"></path>
  <path d="M19 5a9 9 0 010 14"></path>
  </svg>`;

  const soundOffSVG = `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="white" stroke-width="2">
  <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
  <line x1="23" y1="9" x2="17" y2="15"></line>
  <line x1="17" y1="9" x2="23" y2="15"></line>
  </svg>`;

  const heartOutline = `
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="white" stroke-width="2">
  <path d="M16.5 3c-1.74 0-3.41 1.01-4.5 2.61C10.91 4.01 9.24 3 7.5 3
  4.42 3 2 5.42 2 8.5
  c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.31
  C18.6 15.36 22 12.28 22 8.5
  22 5.42 19.58 3 16.5 3z"/>
  </svg>`;

  const heartFilled = `
  <svg viewBox="0 0 24 24" width="22" height="22" fill="#ff3040">
  <path d="M16.5 3c-1.74 0-3.41 1.01-4.5 2.61C10.91 4.01 9.24 3 7.5 3
  4.42 3 2 5.42 2 8.5
  c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.31
  C18.6 15.36 22 12.28 22 8.5
  22 5.42 19.58 3 16.5 3z"/>
  </svg>`;

  /* ================= FLOAT VIDEO ================= */

  if (floatVideo) {
    floatVideo.muted = true;
    floatVideo.play().catch(()=>{});
  }

  /* ================= OPEN MODAL ================= */

  wrapper.addEventListener("click", function (e) {

    if (
      e.target.closest(".reel-float-close") ||
      e.target.closest(".reel-volume-toggle")
    ) return;

    modal.classList.add("active");
    document.body.style.overflow = "hidden";

    if (floatVideo) floatVideo.pause();

    setTimeout(() => playVideoAtIndex(0), 200);
  });

  /* ================= CLOSE MODAL ================= */

  document.addEventListener("click", function (e) {

    if (e.target.closest(".reel-modal-close")) {

      modal.classList.remove("active");
      document.body.style.overflow = "";

      pauseAll();

      if (floatVideo) floatVideo.play().catch(()=>{});
    }
  });

  function pauseAll() {
    videos.forEach(video => {
      video.pause();
      video.currentTime = 0;
    });
  }

  function playVideoAtIndex(index) {

  pauseAll();

  if (videos[index]) {

    const video = videos[index];

    video.muted = !globalSound;

    video.play().catch(()=>{});

    const btn = videos[index]
      .closest(".reel-slide")
      .querySelector(".reel-modal-volume-toggle .icon");

    if(btn){
      btn.innerHTML = video.muted ? soundOffSVG : soundOnSVG;
    }

  }

}

  /* ================= SCROLL AUTO PLAY ================= */

  let currentIndex = 0;

  slider.addEventListener("scroll", function () {

    const newIndex = Math.round(slider.scrollTop / slider.clientHeight);

    if (newIndex !== currentIndex) {
      currentIndex = newIndex;
      playVideoAtIndex(currentIndex);
    }
  });

  /* ================= TAP PLAY / PAUSE ================= */

  document.addEventListener("click", function (e) {

    if (
      e.target.closest(".reel-modal-volume-toggle") ||
      e.target.closest(".reel-share-btn") ||
      e.target.closest(".reel-modal-close") ||
      e.target.closest(".reel-like") ||
      e.target.closest("a")
    ) return;

    const video = e.target.closest(".reel-video-item");
    if (!video) return;

    if (video.paused) video.play().catch(()=>{});
    else video.pause();
  });

  /* ================= MODAL VOLUME ================= */

  document.addEventListener("click", function (e) {

  const btn = e.target.closest(".reel-modal-volume-toggle");
  if (!btn) return;

  const slide = btn.closest(".reel-slide");
  const video = slide.querySelector("video");
  const icon = btn.querySelector(".icon");

  globalSound = video.muted;

  video.muted = !video.muted;

  icon.innerHTML = video.muted ? soundOffSVG : soundOnSVG;
});

  /* ================= FLOATING SOUND ================= */

  document.addEventListener("click", function(e){

    const btn = e.target.closest(".reel-volume-toggle");
    if(!btn) return;

    e.stopPropagation();

    const video = document.querySelector(".reel-video");
    const icon = btn.querySelector(".icon");

    video.muted = !video.muted;
    icon.innerHTML = video.muted ? soundOffSVG : soundOnSVG;
  });

  /* ================= FLOAT CLOSE ================= */

  document.addEventListener("click", function(e){

    const btn = e.target.closest(".reel-float-close");
    if(!btn) return;

    e.stopPropagation();

    document.querySelector(".reel-wrapper").style.display = "none";
  });

  /* ================= SHARE ================= */

  document.addEventListener("click", function (e) {

  const btn = e.target.closest(".reel-share-btn");
  if (!btn) return;

  const productUrl = btn.dataset.url;
  const url = window.location.origin + productUrl;

  const shareBox = btn.closest(".reel-share");
  const productId = shareBox.dataset.id;
  const countEl = shareBox.querySelector(".count");

  let shareKey = "reel_share_" + productId;
  let storedShare = parseInt(localStorage.getItem(shareKey)) || 0;

  storedShare++;

  localStorage.setItem(shareKey, storedShare);

  if(countEl) countEl.textContent = formatCount(storedShare);

  if (navigator.share) {
    navigator.share({
      title: document.title,
      url: url
    });
  } else {
    navigator.clipboard.writeText(url);
    alert("Link Copied!");
  }

});

  /* ================= LIKE + VIEW ================= */

  document.querySelectorAll(".reel-slide").forEach(slide => {

    const video = slide.querySelector("video");
    const likeBtn = slide.querySelector(".reel-like");
    const viewEl = slide.querySelector(".reel-views .count");
    const likeEl = slide.querySelector(".reel-like .count");
    const iconEl = slide.querySelector(".reel-like .icon");

    if (!video || !likeBtn) return;

    const productId = likeBtn.dataset.id;

    let viewsKey = "reel_views_" + productId;
    let likesKey = "reel_likes_" + productId;
    let likedKey = "reel_liked_" + productId;

    let storedViews = parseInt(localStorage.getItem(viewsKey)) || Math.floor(Math.random()*200+100);
    let storedLikes = parseInt(localStorage.getItem(likesKey)) || Math.floor(Math.random()*20+5);

    viewEl.textContent = formatCount(storedViews);
    likeEl.textContent = formatCount(storedLikes);

    if (localStorage.getItem(likedKey)) {
      iconEl.innerHTML = heartFilled;
      likeBtn.classList.add("liked");
    } else {
      iconEl.innerHTML = heartOutline;
    }

    video.addEventListener("play", function () {
      storedViews++;
      localStorage.setItem(viewsKey, storedViews);
      viewEl.textContent = formatCount(storedViews);
    });

    likeBtn.addEventListener("click", function () {

      if (localStorage.getItem(likedKey)) {

        storedLikes--;
        likeBtn.classList.remove("liked");
        iconEl.innerHTML = heartOutline;
        localStorage.removeItem(likedKey);

      } else {

        storedLikes++;
        likeBtn.classList.add("liked");
        iconEl.innerHTML = heartFilled;
        localStorage.setItem(likedKey, "true");
      }

      localStorage.setItem(likesKey, storedLikes);
      likeEl.textContent = formatCount(storedLikes);
    });

  });

  document.querySelectorAll(".reel-share").forEach(box => {

  const productId = box.dataset.id;
  const countEl = box.querySelector(".count");

  let shareKey = "reel_share_" + productId;
  let storedShare = parseInt(localStorage.getItem(shareKey)) || 0;

  if(countEl) countEl.textContent = formatCount(storedShare);

});
  function formatCount(num) {
    if (num >= 1000000) return (num / 1000000).toFixed(1) + "M";
    if (num >= 1000) return (num / 1000).toFixed(1) + "K";
    return num;
  }

});